import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

const IntlMessage = (props) => <FormattedMessage {...props} />

IntlMessage.propTypes = {
  id: PropTypes.string.isRequired,
  values: PropTypes.object,
  defaultMessage: PropTypes.string,
}

export default injectIntl(IntlMessage, {
  withRef: false,
})
